import React from 'react'

const ImageCard = ({ title, description, image, imageAlt, date, startDate, endDate }) => {
  // Date handling: support legacy `date` (single) or `startDate` + `endDate`.
  // Render as "12th  - 21st September 2021" or a single date when equal.
  const ordinal = (d) => {
    const s = ["th", "st", "nd", "rd"]
    const v = d % 100
    return (s[(v - 20) % 10] || s[v] || s[0])
  }

  const formatSingle = (input) => {
    if (!input) return null
    try {
      const dt = input instanceof Date ? input : new Date(input)
      if (isNaN(dt)) return null

      const day = dt.getDate()
      const month = dt.toLocaleString('en-GB', { month: 'long' }) // full month
      const year = dt.getFullYear()

      return `${day}${ordinal(day)} ${month} ${year}`
    } catch (e) {
      return null
    }
  }

  // Determine what to display
  let formattedDate = null
  // Prefer explicit start/end props
  const sDate = startDate || null
  const eDate = endDate || null

  if (sDate && eDate) {
    try {
      const s = sDate instanceof Date ? sDate : new Date(sDate)
      const e = eDate instanceof Date ? eDate : new Date(eDate)
      if (!isNaN(s) && !isNaN(e)) {
        // if same day, show single date
        if (s.toDateString() === e.toDateString()) {
          formattedDate = formatSingle(s)
        } else {
          // show '12th  - 21st September 2021' style: day ordinal for start and end,
          // and full month + year taken from end date for clarity
          const sDay = s.getDate()
          const eDay = e.getDate()
          const eMonth = e.toLocaleString('en-GB', { month: 'long' })
          const eYear = e.getFullYear()
          formattedDate = `${sDay}${ordinal(sDay)}  - ${eDay}${ordinal(eDay)} ${eMonth} ${eYear}`
        }
      }
    } catch (e) {
      formattedDate = null
    }
  } else if (date) {
    // legacy single date prop
    formattedDate = formatSingle(date)
  } else if (sDate && !eDate) {
    // only start date provided
    formattedDate = formatSingle(sDate)
  }

  return (
    // Make the card a fixed square. Use Tailwind to set width and ensure
    // the card doesn't grow. The content area will handle overflow with
    // ellipses via utility classes and a small CSS clamp helper in index.css.
    <div className="w-full h-[400px] flex-shrink-0 border rounded-lg overflow-hidden shadow-sm border-neutral-700 hover:shadow-md transition-shadow bg-neutral-900 flex flex-col">
      {image && (
        // Image occupies the top portion; using object-cover to crop the image
        // so all cards visually match while preserving aspect ratio.
        <div className="w-full h-3/5 overflow-hidden">
          <img
            src={image}
            alt={imageAlt || title || 'card image'}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-4 flex flex-col">
        <h3 className="font-semibold mb-1 clamp-2">{title}</h3>
        {formattedDate && (
          <div className="text-xs text-neutral-500 mb-2 font-medium">{formattedDate}</div>
        )}
        <p className="text-sm text-neutral-400 mt-auto clamp-3">{description}</p>
      </div>
    </div>
  )
}

export default ImageCard